import React, {useState} from 'react'
import {observer} from 'mobx-react'
import './rainbow-gauge.css'

function RainbowGauge({ data, small, min = 0, max = 1, value, title, onClick}) {
  let diff = max - min
  let angle = (value / diff + min) * 180 - 90

  function handleClick() {
    onClick(data, title)
  }

  return (
    <div className={"rainbow-gauge" + (small ? " small" : " big")} onClick={handleClick}>
      <div className="rainbow-gauge-indicator">
        <div className="rainbow-gauge-cursor">
          <div className="rainbow-gauge-cursor-img" style={{transform: `rotate(${angle}deg)`}} />
        </div>
      </div>

      <div className="rainbow-gauge-title">
        {title}
      </div>

    </div>
  )
}

export default observer(RainbowGauge)
